import { MeetingResponse } from 'lib/api/meetings/types';
import { pushToDataLayer } from '../../pushToDataLayer';
import { GTMEvent, GTMEventAttributes, GTMEventName } from '../../types';
import { transformMeetingResponseToGTMAttributes } from './utils';

export function meetingAttributesChangedEvent({
  updatedFields,
  fieldChanges,
  meetingDetails,
  action,
}: {
  updatedFields: string[];
  fieldChanges?: Record<string, any>;
  meetingDetails?: MeetingResponse;
  action: string;
}) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.MEETING_ATTRIBUTES_CHANGED,
  };

  const meetingAttributes =
    transformMeetingResponseToGTMAttributes(meetingDetails);

  pushToDataLayer({
    ...eventAttributes,
    changed_fields: updatedFields,
    ...fieldChanges,
    ...meetingAttributes,
    action,
  });
}
